module.exports = __webpack_public_path__ + "img/worksbot_img20021109.2e2cefc5.jpg";